var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuccess = function SvgSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "206 0 430 456.3"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#005FD5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M534.4 142.738c-2.5.1-4.8 1.1-6.5 2.9L383 290.538l-68.9-68.7a9.476 9.476 0 0 0-13.4 13.4l75.6 75.4c3.7 3.7 9.7 3.7 13.4 0l151.6-151.6c3.8-3.7 3.8-9.7.2-13.4-1.9-1.9-4.4-2.9-7.1-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421 18.638c-115.5 0-209.5 94-209.5 209.5s94 209.5 209.5 209.5 209.5-94 209.5-209.5-94-209.5-209.5-209.5m0 19c105.3 0 190.5 85.3 190.5 190.5 0 105.3-85.3 190.5-190.5 190.5-105.3 0-190.5-85.3-190.5-190.5 0-105.3 85.2-190.5 190.5-190.5"
  }))));
};
export { SvgSuccess as ReactComponent };
export default __webpack_public_path__ + "7238d9cf5895f125e146fde691e5c19c.svg";